export default {
  userMetadata: {
    firstName: 'Имя',
    lastName: 'Фамилия',
    middleName: 'Отчество',
    fullName: 'ФИО',
    city: 'Город',
    address: 'Адрес',
    TIN: 'ИНН',
    phone: 'Телефон',
    password: 'Пароль',
    email: 'Эл.почта',
    messengers: 'Мессенджеры',
    website: 'Сайт',
    specialization: 'Специализация',
    teams: 'Команды',
    level: 'Уровень',
    salary: 'Заработная плата',
    startOfWorkCompany: 'Начало работы в компании',
    position: 'Должность',
    startOfWorkPosition: 'Начало работы в должности',
    birthdate: 'Дата рождения',
    familyStatus: 'Семейное положение',
    children: 'Дети',
    education: 'Образование',
    specialty: 'Специальность',
  },
  familyStatuses: {
    widower: 'Вдовец (вдова)',
    neverMarried: 'Никогда не состоял(а) в браке',
    divorced: 'Разведен(а) официально (развод зарегистрирован)',
    brokeUp: 'Разошелся(лась)',
    married: 'Состоит в зарегистрированном браке',
    unregisteredMarriage: 'Состоит в незарегистрированном браке',
  },
  homePage: 'Главная',
  myProfile: 'Мой профиль',
  myProgress: 'Мой прогресс',
  myTasks: 'Мои задачи',
  assignedToMe: 'Мне назначено',
  myMeetings: 'Мои встречи',
  myLevel: 'Мой текущий уровень',
  myCompany: 'Моя компания',
  myCompanies: 'Мои компании',
  myResume: 'Моё резюме',
  resume: 'Резюме',
  curatedByMe: 'Я курирую',
  administration: 'Конструктор профилей',
  adminArea: 'Администрирование',
  users: 'Пользователи',
  usersManagement: 'Управление пользователями',
  companiesManagement: 'Управление компаниями',
  administrator: 'Администратор',
  staffManagement: 'Управление персоналом',
  teamManagement: 'Управление командой',
  progress: 'Прогресс',
  profile: 'Профиль',
  defaultProfiles: 'Профили по умолчанию',
  taskBoard: 'Доска задач',
  taskBoards: 'Планы развития',
  company: 'Компания',
  companies: 'Компании',
  companyName: 'Название компании',
  companyProfile: 'Профиль компании',
  feedbackFeed: 'Лента фидбэка',
  companyFeed: {
    title: 'Лента',
    settings: 'Настройки ленты',
    settingsHint: 'Отметьте вопросы, которые необходимо скрыть из ленты',
    placeholder:
      'В ленте пока ничего нет. Для появления комментариев, дождитесь, когда организатор назначит опрос.',
  },
  orgStructure: 'Орг. структура',
  licensing: 'Лицензирование',
  branding: 'Брендирование',
  logotype: 'Логотип',
  modules: 'Модули',
  modulesMetadata: {
    adaptation: {
      title: 'Адаптация',
      description:
        'Автоматизация онбординга, адаптации и ввода в должность через чат-бот в Телеграм.<br/>Конструктор адаптационных треков и готовые шаблоны.<br/>Отслеживание прогресса на всём пути адаптации сотрудника.',
    },
    evaluation: {
      title: 'Оценка и развитие',
      description:
        'Проведение регулярных аттестаций или точечных оценок сотрудников<br/>Конструктор профилей с готовыми шаблонами.<br/>Оценка 360/180 с гибкими настройками и автоматическим ИПР по результатам.<br/>Сотрудники могут проходить опросы в интерфейсе платформы, а также через HRChain-bot в Телеграм.<br/>Индивидуальные и сводные отчёты.',
    },
    targets: {
      title: 'Цели',
      description:
        'Функционал по постановке и трекингу целей сотрудников.<br/>Поможет оценивать результативность команды в режиме реального времени.<br/>Модуль позволяет ставить задачи и цели на разные периоды времени и приоритизировать их, собирать итоги и видеть отчёт по всей команде, по подразделению или по конкретному человеку. С его помощью вы сможете определять цели на развитие или испытательный срок и хранить всю историю эффективности ваших сотрудников.',
    },
    meetings: {
      title: 'Встречи',
      description:
        'Планирование и проведение встреч 1 на 1.<br/>Отслеживание встреч при помощи календаря.<br/>Фиксация результатов и задач по итогам встреч.',
    },
    testsAndSurveys: {
      title: 'Тесты и опросы',
      description:
        'Конструктор опросов и тестов для проведения HR исследований и оценки знаний сотрудников.<br/>Готовые шаблоны исследований с лучшими HR-практиками.<br/>Готовое решение для оценки удовлетворенности, лояльности (eNPS), вовлечённости и выгорания сотрудников.<br/>Формирование культуры вовлечения за счёт регулярного и простого формата проведения.',
    },
    feedback: {
      title: 'Фидбэк (непрерывная обратная связь)',
      description:
        'Непрерывная обратная связь по методу, объединяющему в себе оценку 360 градусов и пульс-опросы сотрудников.<br/>Умные опросы, в которых сотрудники дают обратную связь своим коллегам.<br/>Интеллектуальный подбор взаимодействующих на основе реальных коммуникаций сотрудников.<br/>Доступ к методологии «Эффективность сотрудников», которая содержит вопросы по компетенциям, эффективности и благополучию сотрудников.',
    },
    interconnect: {
      title: 'Аналитика коммуникаций',
      description:
        'Анализ коммуникаций и реального рабочего процесса в компании на основании данных почты, календаря и систем управления задачами.',
    },
    htTests: {
      title: 'Личностное тестирование',
      description:
        'Психологические тесты.<br/>Оценка мотивации сотрудника или всей команды, структуры личности и потенциала сотрудника, сборка команды по ролям Белбина.',
    },
    resume: {
      title: 'Моё резюме',
      description:
        'Позволяет разместить портфолио, указать места работы и подробно заполнить блок о себе.',
    },
  },
  contacts: 'Контакты',
  documents: 'Документы',
  instructions: 'Инструкции',
  legalInfo: 'Правовая информация',
  backgroundInfo: 'Справочная информация',
  addInfo: 'Дополнительная информация',
  aboutCompany: 'О компании',
  jobInfo: 'Сведения о работе',
  changelog: 'Обновления ПО',
  telegramBot: 'Телеграм бот',
  aboutMe: 'Обо мне',
  employee: 'Сотрудник',
  employees: 'Сотрудники',
  employeeStatuses: {
    current: 'Действующие',
    dismissed: 'Уволенные',
    invited: 'Приглашённые',
  },
  team: 'Команда',
  teams: 'Команды',
  withoutTeam: 'Без команды',
  group: 'Группа',
  leader: 'Лидер',
  surveys: 'Опросы',
  survey: 'Опрос',
  result: 'Результат',
  surveyResults: 'Результаты опроса',
  periodicSurvey: 'Периодический опрос',
  recipients: 'Получатели',
  periodLimit: 'Период прохождения теста',
  periodExpired: 'Установленный период истёк',
  surveysTypes: {
    engagement: 'Вовлеченность и удовлетворенность',
    burnout: 'Выгорание',
    corporateCulture: 'Корпоративная культура',
  },
  surveysMetadata: {
    surveys: {
      title: 'Опросы',
      periodic: 'Периодический опрос',
      nonperiodic: 'Непериодический опрос',
      report: 'Сводка',
      details: 'По отдельным пользователям',
      emplStatistic: 'Сотрудников прошли опрос',
      allQuestions: 'Все',
      createButton: 'Создать новый опрос',
      surveyDone: 'Опрос пройден',
      surveyPlaceholder: 'Пока нет назначенных или незавершенных опросов',
      table: {
        headers: {
          name: 'Название опроса',
          lastSend: 'Посл. отправка',
          nextSend: 'След. отправка',
          dateStart: 'Дата старта',
          dateEnd: 'Дата окончания',
          period: 'Период',
          count: 'Статистика',
          status: 'Статус',
        },
      },
      statuses: {
        draft: 'Черновик',
        published: 'Опубликован',
      },
      changeButton: 'Редактировать опрос',
      menu: {
        sendToParticipants: 'Назначить участников',
        sendNow: 'Отправить опрос сейчас',
        reSendNow: 'Отправить напоминание',
        makeUnavailable: 'Скрыть из доступа',
        makeAvailable: 'Сделать доступным',
        exportResults: 'Выгрузить результаты',
        copyLink: 'Скопировать ссылку',
        copyEntity: 'Скопировать опрос',
        copyEntityTo: 'Скопировать в другую компанию',
        del: 'Удалить опрос',
      },
      successMessages: {
        changeStatus: 'Доступность опроса успешно изменена',
        copyEntity: 'Копирование опроса успешно завершено',
        sendNow: 'Опрос отправлен участникам',
      },
      errorMessages: {
        changeStatus: 'Не удалось изменить доступность опроса',
        copyEntity: 'Не удалось скопировать опрос',
        sendNow: 'Не удалось отправить опрос',
        copyEntityNotSelected: 'Не выбрана ни одна компания',
      },
    },
    tests: {
      title: 'Тесты',
      unregistered: 'Незарегистрированный пользователь',
      validAnswers: 'Результат',
      periodic: 'Периодический тест',
      nonperiodic: 'Непериодический тест',
      createButton: 'Создать новый тест',
      testDone: 'Тест пройден',
      testPlaceholder: 'Пока нет назначенных тестов',
      table: {
        headers: {
          name: 'Название теста',
          lastSend: 'Посл. отправка',
          nextSend: 'След. отправка',
          dateStart: 'Дата старта',
          dateEnd: 'Дата окончания',
          period: 'Период',
          count: 'Кол-во прошедших тест',
          availability: 'Разрешено проходить гостям',
          status: 'Статус',
        },
      },
      statuses: {
        draft: 'Черновик',
        published: 'Опубликован',
      },
      changeButton: 'Редактировать тест',
      menu: {
        sendToParticipants: 'Назначить участников',
        sendNow: 'Отправить тест сейчас',
        makeUnavailable: 'Скрыть из доступа',
        makeAvailable: 'Сделать доступным',
        exportResults: 'Выгрузить результаты',
        copyLink: 'Скопировать ссылку',
        copyEntity: 'Скопировать тест',
        copyEntityTo: 'Скопировать в другую компанию',
        del: 'Удалить тест',
      },
      successMessages: {
        changeStatus: 'Доступность теста успешно изменена',
        copyEntity: 'Копирование теста успешно завершено',
        sendNow: 'Тест отправлен участникам',
      },
      errorMessages: {
        changeStatus: 'Не удалось изменить доступность теста',
        copyEntity: 'Не удалось скопировать тест',
        sendNow: 'Не удалось отправить тест',
        copyEntityNotSelected: 'Не выбрана ни одна компания',
      },
    },
    availability: {
      availabilityTooltip:
        'Разрешено проходить неавторизованным пользователям. Результаты прохождения будут обезличены.',
      availabilityGuestTooltip:
        'Результаты прохождения опроса/теста не будут отображать сведения о пользователе.',
      availabilityNotGuestTooltip:
        'Результаты прохождения опроса/теста отображают сведения обо всех пользователях, если пользователь не авторизован, то его ответы будут помечены как ответы гостя.',
    },
    cycle: 'Цикл',
    individualLinks: 'Генерация индивидуальных ссылок',
    individualLinksHint:
      'Доступно при назначении участников. Участники получат индивидуальные ссылки для прохождения, авторизация не потребуется',
    questions: {
      notFound: 'Тип вопроса не распознан',
      default: '- Выберите тип вопроса -',
      boolean: 'Да или Нет',
      multi_choice: 'Мультивыбор',
      number: 'Число',
      single_choice: 'Единичный выбор',
      text: 'Короткий текст',
      date: 'Дата',
      textarea: 'Длинный текст',
      file: 'Файл',
      scale: 'Шкала',
      phone: 'Телефон',
      time: 'Время',
    },
    questionFields: {
      units: 'Единицы измерения',
      minMax: 'Мин/макс значение',
      validAnswer: 'Правильный ответ',
      showValidAnswer: 'Указать правильный ответ',
      unitsPlaceholder: 'Например: шт, кг, дней',
      from: 'От',
      to: 'До',
      decimals: 'Разрешить десятичные',
      answerVariants: 'Варианты ответа',
      scaleMaxLength: 'Максимальная длина названий: 30 символов',
      scaleMaxLengthHint:
        'Шкала будет отображаться в горизонтальном положении, в полях «Начало и конец шкалы» вы можете указать текстовые или числовые значения, с ограничением в 30 символов',
      answerVariantsPlaceholder: 'Введите название варианта ответа',
      addVariant: 'Добавить ещё вариант',
      delVariant: 'Удалить вариант',
      pointCount: 'Количество точек',
      startsWith: 'Начало со значения «1»',
      scaleBegin: 'Начало шкалы',
      scaleBeginPh: 'Введите название первой точки',
      scaleEnd: 'Конец шкалы',
      scaleEndPh: 'Введите название последней точки',
      maxLength: 'Ограничение длины',
      addFile: 'Прикрепить файл',
      addedFile: 'Прикреплённый файл',
      surveyTextQuestionLabel: 'Ответ',
      surveyTextQuestionTooltip: 'Дайте краткий ответ, ограничение в символах: {text_limit}',
      showInFeed: 'Включить отображение вопроса в ленте',
      showInFeedHint: 'Ответ будет опубликован в ленте <strong>без указания вашего имени</strong>',
      question: 'Вопрос',
      questionPlaceholder: 'Введите текст вопроса',
      qType: 'Тип вопроса',
      showRich: 'Включить расширенное описание вопроса',
      richBody: 'Расширенное описание',
      surveySettingsAdditional: 'Оценка результата не включена',
      surveySettingsAdditionalBtn: 'Включить',
      surveySettingsAdditionalLink: 'Перейти к настройке оценки результатов',
      newOption: 'Новый вариант',
      copyQuestion: 'Копировать вопрос',
      copyPrefix: 'Копия',
      editQuestion: 'Редактировать вопрос',
      deleteForever: 'Удалить без возможности восстановления',
      moveDown: 'Переместить ниже',
      moveUp: 'Переместить выше',
      restore: 'Восстановить',
      finishButtonName: 'Завершить прохождение',
      addQuestion: 'Добавить вопрос',
      deleted: 'Вопрос {num} удалён',
    },
    feedbacks: {
      title: 'Фидбэк',
      report: 'Сводка',
      details: 'По отдельным пользователям',
      summaryOfQuestions: 'Сводная по вопросам',
      emplStatistic: 'Сотрудников прошли опрос',
      allQuestions: 'Все',
      surveyDone: 'Опрос пройден',
      createButton: 'Создать фидбэк',
      changeButton: 'Редактировать фидбэк',
      managingMethodologies: 'Управление методологиями',
      methodology: 'Методология',
      commonMethodology: 'Общая методология',
      listOfQuestions: 'Список вопросов',
      placeholder:
        'Здесь будут отображаться опросы и результаты прохождения. Для начала оценки нажмите кнопку «Создать фидбэк».',
      table: {
        headers: {
          name: 'Название',
          status: 'Статус',
          lastStart: 'Старт цикла',
          nextStart: 'Старт следующего цикла',
          count: 'Статистика',
          cycle: 'Цикл',
        },
      },
      statuses: {
        started: 'Запущен',
        stopped: 'Остановлен',
      },
      menu: {
        copyEntity: 'Скопировать фидбэк',
        deleteEntity: 'Удалить фидбэк',
      },
      infoMessages: {
        start:
          'При запуске начнётся отправка частей опросов в выбранные дни недели. Если опрос ранее был остановлен, то начнётся новый цикл отправки, т.е. опросы начнут приходить сначала. Запланированные отправки частей опросов из предыдущего цикла будут аннулированы.',
        stop: 'Отправки частей опросов из данного цикла будут продолжаться, пока опрос не будет пройден полностью, но новый цикл опросов не будет начат.',
      },
      successMessages: {
        copyEntity: 'Копирование опроса успешно завершено',
        deleteEntity: 'Опрос успешно удалён',
      },
      errorMessages: {
        copyEntity: 'Не удалось скопировать опрос',
        deleteEntity: 'Не удалось удалить опрос',
      },
    },
    researchment: {
      title: 'Исследования',
      titleOne: 'Исследование',
      buttons: {
        started: 'Остановить',
        stopped: 'Запустить',
        paused: 'Продолжить',
      },
      statuses: {
        started: 'Запущено',
        stopped: 'Остановлено',
        paused: 'Пауза',
      },
    },
  },
  dashboardMetadata: {
    titles: {
      competencies360: 'Компетенции (по 360)',
      knowledge: 'Знания',
      personalPotential: 'Личностный потенциал',
      conflictLevel: 'Уровень конфликтности',
      managementStyle: 'Стиль менеджмента (Адизес)',
      teamRoles: 'Роли в команде (Белбин)',
      targets: 'Цели',
      feedbacks: 'Фидбэки',
    },
    managementStyles: {
      unusual: 'Несвойственный стиль',
      lackOfTrends: 'Отсутствие тенденций',
      moderate: 'Умеренное выражение стиля',
      vivid: 'Яркая выраженность стиля',
    },
    teamRoles: {
      preferredRoles: 'Наиболее приемлемые',
      unwantedRoles: 'Наименее приемлемые',
    },
  },
  meetings: 'Встречи',
  meeting: 'Встреча',
  tests: 'Тесты',
  test: 'Тест',
  question: 'Вопрос',
  section: 'Раздел',
  answer: 'Ответ',
  testBySpec: 'Тест по специализации',
  pulseTest: 'Пульс-опрос',
  pulseSpec: 'Пульс-специализация',
  scoreType: 'Вид оценки',
  duration: 'Длительность',
  comment: 'Комментарий',
  comments: 'Комментарии',
  autofill: 'Автоподбор',
  status: 'Статус',
  participant: 'Участник',
  scoreAndDevelopment: 'Оценка и развитие',
  score: 'Оценка',
  score360: 'Оценка 360',
  overallScore360: 'Общая (с самооценкой)',
  compositionAssessment: 'Состав оценки',
  approvalScore360: 'Утверждение взаимодействующих для оценки 360',
  negativeScore: 'н/о',
  averageScore: 'Средняя оценка',
  teamRoles: 'Роли в команде',
  testsTypes: {
    tests360: 'Оценка 360',
    self360: 'Самооценка 360',
    approval360: 'Утвердить список',
    pulseTests: 'Пульс-опросы',
    self: 'Самооценка',
    withSelf: 'С самооценкой',
    withoutSelf: 'Без самооценки',
    notSelf: 'По другим пользователям',
    selfApproval: 'По себе',
    notSelfApproval: 'По другим пользователям',
    personal: 'Личностные тесты',
    bhPersonal: 'Тесты HRChain',
    htPersonal: 'Тесты партнёров',
    feedback: 'Фидбэк',
  },
  licenseCount: 'Количество лицензий',
  unlimitedLicenses: 'Количество лицензий не ограничено',
  skill: 'Навык',
  skills: 'Навыки',
  skillsType: 'Тип навыков',
  skillsTypes: {
    soft: 'Soft skills',
    hard: 'Hard skills',
    motivation: 'Направление развития карьеры и мотивация',
    teamRoles: 'Структура личности и роли в команде',
    leaderChart: 'LeaderChart (IT)',
    BPProfileExpress: 'Бизнес-Профиль Express',
    lineManagementControlSkills: 'Навыки управления - Линейный менеджмент',
    bhMotivation: 'Личностное тестирование',
  },
  competence: 'Компетенция',
  competencies: 'Компетенции',
  competenceBlock: 'Блок компетенций',
  indicator: 'Индикатор',
  openQuestion: 'Открытый вопрос',
  openQuestions: 'Открытые вопросы',
  completionStatuses: {
    completed: 'Завершён',
    notCompleted: 'Не завершён',
  },
  passStatuses: {
    passed: 'Пройден',
    notPassed: 'Не пройден',
  },
  approvalStatuses: {
    awaitingCreator: 'На подтверждении у создателя',
    awaitingEvaluated: 'На подтверждении у сотрудника',
    awaitingSupervisor: 'На подтверждении у руководителя',
    pending: 'На подтверждении',
    approved: 'Подтверждён',
    started: 'Запущен',
    rejected: 'Отклонён',
    cancelled: 'Отменён',
  },
  approvalEvaluatedStatuses: {
    pending: 'На подтверждении у оцениваемого',
    approved: 'Подтверждён оцениваемым',
    rejected: 'Отклонён оцениваемым',
  },
  type: 'Тип',
  preview: 'Превью',
  environment: 'Окружение',
  supervisors: 'Руководители',
  subordinates: 'Подчинённые',
  colleagues: 'Коллеги',
  experts: 'Эксперты',
  expertGroups: {
    allWithoutEvalAndSupervisor: 'Все без оцениваемого и руководителя',
    allWithoutSelf: 'Все без самооценки',
    allWithoutSelfAndSupervisor: 'Все без самооценки и руководителя',
    all: 'Все группы',
  },
  expertRoles: {
    evaluated: 'Оцениваемый',
    supervisor: 'Руководитель',
    subordinate: 'Подчинённый',
    colleague: 'Коллега',
  },
  reEvaluationLock: 'Настройка закрытия сеансов',
  changeTestsSettings: 'Настройка назначения оценки',
  editEmails: 'Редактирование писем',
  report: 'Отчёт',
  reports: 'Отчёты',
  fixedDevPlan: 'Зафиксированный ИПР',
  devPlan: 'План развития',
  devPlans: 'Планы развития',
  materials: 'Материалы',
  commonMaterials: 'Общие материалы',
  adaptationPlans: 'Планы адаптации',
  dayOfAdaptation: 'День адаптации',
  roadmapsTypes: {
    roadmap: 'ИПР по самооценке',
    roadmap360: 'ИПР по 360',
  },
  stopFactor: 'стоп-фактор',
  importance: 'Важность',
  importanceTypes: {
    extra: 'Экстренная',
    high: 'Высокая',
    middle: 'Средняя',
    low: 'Низкая',
    noMatter: 'Не имеет значения',
  },
  conflictLevels: {
    high: 'Высокий',
    mid: 'Средний',
    low: 'Низкий',
  },
  target: 'Цель',
  targets: 'Цели',
  targetLevel: 'Целевой уровень',
  period: 'Период',
  schedule: 'Расписание',
  date: 'Дата',
  dateStart: 'Дата старта',
  deadline: 'Дедлайн',
  version: 'Версия',
  currentVersion: 'Тек. версия',
  mentor: 'Наставник',
  mentors: 'Наставники',
  adaptation: 'Адаптация',
  adaptations: 'Адаптации',
  interactionDiagram: 'Диаграмма взаимодействия',
  testing: 'Тестирование',
  plan: 'План',
  startDate: 'Дата старта',
  creationDate: 'Дата назначения',
  task: 'Задача',
  tasks: 'Задачи',
  currentList: 'Текущие',
  currentTasks: 'Текущие задачи',
  archive: 'Архив',
  portfolio: 'Портфолио',
  layout: 'Обложка',
  services: 'Услуги',
  workExp: 'Опыт работы',
  organizers: 'Организаторы',
  organizer: 'Организатор',
  managers: 'Менеджеры',
  manager: 'Менеджер',
  education: 'Образование',
  teamMembers: 'Состав команды',
  feedbacks: 'Фидбэки',
  massAssignment: 'Массовое назначение',
  name: 'Название',
  educationLevels: {
    top: 'Высшее образование',
    bachelor: 'Высшее образование - бакалавриат',
    magister: 'Высшее образование - специалитет, магистратура',
    topHighest: 'Высшее образование - подготовка кадров высшей квалификации',
    candidate: 'Кандидат наук',
    adjunct: 'Адъюнктура',
    aspirant: 'Аспирантура',
    doctor: 'Докторантура',
    auxKidsAdults: 'Дополнительное образование для детей и взрослых',
    auxProf: 'Дополнительное профессиональное образование',
    infants: 'Дошкольное образование',
    intern: 'Интернатура',
    starterCommon: 'Начальное общее образование',
    starterProf: 'Начальное профессиональное образование',
    unfinishedTop: 'Неполное высшее образование',
    ordinate: 'Ординатура',
    mainCommon: 'Основное общее образование',
    afterUni: 'Послевузовское образование',
    profTraining: 'Профессиональное обучение',
    middleFull: 'Среднее (полное) общее образование',
    middle: 'Среднее общее образование',
    middleSpecial: 'Среднее профессиональное образование',
  },
  specialty: 'Специальность',
  specialization: 'Специализация',
  specializations: 'Специализации',
  statistics: 'Статистика',
  analytics: 'Аналитика',
  interconnect: 'Диаграмма взаимодействий',
  settings: 'Настройки',
  commonSettings: 'Общие настройки',
  demoAccess: 'Демо доступ',
  banStatuses: {
    blocked: 'Заблокировано',
    unblocked: 'Разблокировано',
  },
  buttons: {
    archive: 'Перенести в архив',
    share: 'Поделиться',
    export: 'Экспорт',
    exportToExcel: 'Выгрузить в Excel',
    exportReport: 'Выгрузить отчёт',
    exportToPDF: 'Выгрузить в PDF',
    copy: 'Копировать',
    download: 'Скачать',
    downloadDocument: 'Скачать документ',
    downloadAllFiles: 'Скачать все файлы',
    downloadTemplate: 'Скачать шаблон',
    uploadSpecialization: 'Загрузить специализацию',
    expandAll: 'Развернуть всё',
    collapseAll: 'Свернуть всё',
    collapseText: 'Свернуть',
    show: 'Показать',
    hide: 'Скрыть',
    loadMore: 'Показать ещё',
    loadMoreText: 'Показать больше',
    toTop: 'Наверх',
    link: 'Перейти',
    save: 'Сохранить',
    saveChanges: 'Сохранить изменения',
    create: 'Создать',
    fixate: 'Зафиксировать версию',
    generate: 'Сформировать',
    restart: 'Перезапустить',
    refresh: 'Обновить',
    find: 'Найти',
    remind: 'Напомнить',
    edit: 'Редактировать',
    configure: 'Настроить',
    configureComments: 'Настроить комментарии',
    configureGroups: 'Настроить группы',
    configureParams: 'Настроить параметры',
    change: 'Изменить',
    add: 'Добавить',
    addAnother: 'Добавить ещё',
    addTask: 'Добавить задачу',
    addLink: 'Добавить ссылку',
    addQuestion: 'Добавить вопрос',
    addQuestions: 'Добавить вопросы',
    addToBoard: 'Добавить на доску',
    addTarget: 'Добавить цель',
    addComment: 'Добавить комментарий',
    addTag: 'Добавить тэг',
    editQuestions: 'Редактировать вопросы',
    editTask: 'Редактировать задачу',
    appoint: 'Назначить',
    disabled: 'Отключено',
    enabled: 'Включено',
    assignPlan: 'Назначить план',
    createTests: 'Назначить тесты',
    createScore: 'Назначить оценку',
    sendScore: 'Отправить оценку',
    completeScore: 'Завершить оценку',
    sendForApproval: 'Отправить на согласование',
    send: 'Отправить',
    evaluate: 'Оценить',
    evaluateAgain: 'Оценить повторно',
    takeTest: 'Пройти тест',
    takeSurvey: 'Пройти опрос',
    takeTestAgain: 'Пройти тест повторно',
    continueTest: 'Продолжить тест',
    devPlan: 'и получить план развития',
    compositionOfParticipants: 'Состав участников',
    approveList: 'Утвердить список',
    createReport: 'Сформировать отчёт',
    createDevPlan: 'Сформировать ИПР',
    checkReport: 'Проверить отчёт',
    checkDevPlan: 'Проверить ИПР',
    createDiagram: 'Построить диаграмму',
    completeTest: 'Завершить тест',
    complete: 'Завершить',
    invite: 'Отправить приглашения',
    accept: 'Принять',
    reject: 'Отклонить',
    approve: 'Подтвердить',
    open: 'Открыть',
    openAll: 'Открыть всё',
    openScore: 'Открыть оценку',
    select: 'Выбрать',
    selectAll: 'Выбрать всё',
    selectAllPeople: 'Выбрать всех',
    choosePhoto: 'Выбрать фото',
    deselect: 'Снять выбор',
    reset: 'Сбросить',
    cancel: 'Отмена',
    cancelAction: 'Отменить',
    cancelTest: 'Отменить тест',
    recover: 'Восстановить',
    delete: 'Удалить',
    deleteAll: 'Удалить всё',
    confirm: 'Да',
    confirmDelete: 'Да, удалить',
    confirmAdd: 'Да, добавить',
    close: 'Закрыть',
    closeAll: 'Закрыть всё',
    closeScore: 'Закрыть оценку',
    closeTesting: 'Выйти из теста',
    login: 'Войти',
    exit: 'Выйти',
    clear: 'Понятно',
    okay: 'Хорошо',
    done: 'Готово',
    continue: 'Далее',
    back: 'Назад',
    goBack: 'Вернуться назад',
    goToDashboard: 'Перейти в профиль',
    goToBoard: 'Перейти на доску',
    moveUp: 'Вверх',
    moveDown: 'Вниз',
    moveToCurrent: 'Перенести в текущие',
    transfer: 'Перенести',
    applyFilter: 'Применить фильтр',
    editFilter: 'Настроить фильтр',
    clearFilter: 'Очистить фильтр',
    clearField: 'Очистить поле',
    block: 'Заблокировать',
    unblock: 'Разблокировать',
    action: 'Действия',
    readAll: 'Прочитать всё',
    inDynamics: 'В динамике',
    showReports: 'Показать отчёты',
    hideReports: 'Скрыть отчёты',
    getToWork: 'Взять в работу',
    logging: 'Логирование',
    start: 'Начать',
  },
  toggleGroups: {
    participateTypesHint: 'Здесь можно выбрать кому будет доступно прохождение опроса/теста',
    participateTypes: {
      guest: 'Прохождение доступно всем пользователям, авторизованным и неавторизованным',
      authorized: 'Прохождение доступно только авторизованным пользователям',
      assigned:
        'Прохождение доступно по индивидуальной ссылке пользователям, на которых назначен опрос/тест',
      names: {
        guest: 'Разрешено\nгостям',
        authorized: 'Только\nавторизованным',
        assigned: 'По индивидуальной\nссылке',
      },
    },
    participateAnonymousHint:
      'Здесь можно ограничить сбор данных пользователя. Не влияет на доступность прохождения',
    participateAnonymousHintDisabled:
      'Здесь можно ограничить сбор данных пользователя. Не влияет на доступность прохождения. Не будет применена к запущенным опросам/тестам, или если в них уже есть ответы',
    participateAnonymous: {
      anonymousName: 'Анонимный\nопрос',
      anonymous: 'Результаты прохождения опроса/теста не будут отображать сведения о пользователе',
      notAnonymousName: 'Неанонимный\nопрос',
      notAnonymous:
        'Результаты прохождения опроса/теста отображают сведения обо всех пользователях, если пользователь не авторизован, то его ответы будут помечены как ответы гостя',
    },
  },
  inputs: {
    file: 'Выберите файл',
    image: 'Выберите изображение',
  },
  loading: 'Загрузка...',
  search: 'Поиск',
  searchByFullName: 'Поиск по ФИО',
  searchByCompanyName: 'Поиск по названию компании',
  searchByTitle: 'Поиск по названию',
  searchByTeam: 'Поиск по команде',
  searchByTeamGroup: 'Поиск по подразделению',
  searchByGroup: 'Поиск по группе',
  searchBySpec: 'Поиск по специализации',
  searchByQuestion: 'Поиск по вопросу',
  link: 'Ссылка',
  image: 'Изображение',
  file: 'Файл',
  tags: 'Тэги',
  variables: 'Переменные',
  tagsMetadata: {
    editTags: 'Добавление тэгов',
    addTag: 'Создать новый',
    noData: 'Для добавления введите больше трёх символов',
    noDataHint: 'Тэг "<strong>{searchInput}</strong>" не найден',
    noDataHint1: ', но вы можете',
    noDataSelect: 'Выберите тэг из списка, или добавьте новый',
    successMessage: 'Тэги успешно изменены',
    errorMessage: 'Не удалось изменить тэги',
  },
  description: 'Описание',
  instruction: 'Инструкция',
  info: {
    copyText: 'Текст скопирован',
    copyLink: 'Ссылка скопирована',
  },
  socialNetworks: {
    behance: 'Behance',
    facebook: 'Facebook',
    github: 'GitHub',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    ok: 'OK',
    stackoverflow: 'Stack Overflow',
    telegram: 'Telegram',
    twitter: 'Twitter',
    vk: 'VK',
    skype: 'Skype',
  },
  stubs: {
    noItems: 'Вы пока не добавили ни одного элемента',
    noInfo: 'Нет информации',
    noData: 'Отсутствуют данные',
    noTitle: 'Без названия',
    nothingFound: 'Ничего не найдено',
    notSpecified: 'Не указано',
    noDescription: 'Нет описания',
    cityNotSpecified: 'Город не указан',
    leaderNotSpecified: 'Лидер не назначен',
    companyNotSelected: 'Компания не выбрана',
    notCompleted: 'Не завершён',
    notSelected: 'Не выбрано',
    notAssigned: 'Не назначено',
    noSpecs: 'Нет специализаций',
    noVersions: 'Нет версий',
    noComment: 'Без комментария',
    noComments: 'Без комментариев',
    noQuestions: 'Нет вопросов',
    noAnswers: 'Ещё нет ответов',
    noTheme: 'Без тематики',
    withoutTeam: 'Без команды',
    teamSpecsNotSelected:
      'Командные специализации не выбраны. Вы можете выбрать их нажав на кнопку «Редактировать» возле имени пользователя или на вкладке «Состав команды»',
    noSkills: 'Отсутствуют навыки для оценки',
    noCompanies: 'Нет компаний',
    noEmployees: 'Нет сотрудников',
    noSubEmployees: 'Нет подчинённых сотрудников',
    noTests: 'Не было назначено ни одного тестирования',
    noTeams: 'Нет команд',
    noMembers: 'Нет участников',
    noScore: 'Не было назначено ни одной оценки',
    noIndicator: 'Ни один индикатор не попал в данную категорию',
    noResults: 'Нет результатов',
    noMethodology:
      'У вас ещё нет ни одной методологии. Чтобы создать методологию, нажмите на кнопку «Создать методологию»',
    noTemplate:
      'У вас ещё нет ни одного шаблона. Чтобы создать шаблон, создайте исследование и сохраните его как шаблон',
    noAccessRights: 'Недостаточно прав для просмотра этой страницы',
    testsNoPass: 'Тесты не пройдены',
    BCHCompany: 'Компания {name} из БЧ',
  },
  placeholders: {
    name: 'Введите название',
    enterValue: 'Введите значение',
    enterAnswer: 'Введите ответ',
    specifyNumber: 'Укажите число',
    select: 'Выберите из списка',
    statisticInterval: 'Данные за последние 60 дней',
    teamsSelect: 'По всей компании',
    selectCompany: 'Выберите компанию',
    selectEmployees: 'Выберите сотрудников',
    all: 'Все',
  },
  formLabels: {
    name: 'Название',
    userName: 'ФИО сотрудника',
    description: 'Описание',
    allCompany: 'Вся компания',
    allTeams: 'Все команды',
  },
  tooltips: {
    employees:
      'Показывает количество сотрудников на текущую дату. Не зависит от выбранного периода',
    adaptation:
      'Количество сотрудников хотя бы с одним не завершенным планом адаптации. Не зависит от выбранного периода',
    score360:
      'Статистика по запущенным оценкам 360 за выбранный период. Карты развития учитываются только зафиксированные',
    pulseTests:
      'Активность сотрудников по отправленным опросам, которые являются периодической рассылкой. В статистике не учитываются опросы, отправленные по ссылке',
    personalTests:
      'Статистика по психологическим тестам. Блок не зависит от фильтров по команде и дате. Для пополнения лицензий обратитесь в техническую поддержку',
    testing:
      'Статистика по запущенным тестам. В статистике не учитываются тесты, отправленные по ссылке',
    remindTests:
      'Для отправки напоминаний по тесту, установите чекбокс и нажмите на кнопку «Напомнить»',
    support: 'Написать в техподдержку',
    targets:
      'Статистика по поставленным целям отображает общее количество целей и среднюю оценку эффективности по всем сотрудникам компании. Вывод статистики по блоку цели не зависит от выбранного периода',
  },
  attention: 'Внимание',
  required: 'Обязательный',
  hint: 'Подсказка',
  uploaded: 'Загружено',
  total: 'Итого',
  sent: 'Отправлено',
  string: 'Строка',
  success: 'Успешно',
  error: 'Ошибка',
  errorMessages: {
    default: 'Не удалось загрузить данные',
    getEmployee: 'Не удалось получить данные о пользователе',
    userPlatformRights: 'Не удалось загрузить права пользователя',
    permissionDenied: 'Недостаточно прав',
    exportReport: 'Не удалось выгрузить отчёт',
    htPersonalTests: 'Тесты «Мотивация и роли в команде» временно не доступны',
    bhPersonalTests: 'Не удалось загрузить личностное тестирование',
    specializations:
      'Создайте специализации для компании {company_id}, иначе страница команды будет недоступна',
    someBroken: 'Ой, что-то сломалось',
    pageNotFound:
      'К сожалению, запрашиваемая страница не найдена. Возможно, вы перешли по ссылке, в которой была допущена ошибка или страница была удалена',
    timeoutExpired:
      'Превышено время ожидания. Пожалуйста, попробуйте еще раз или свяжитесь с поддержкой.',
  },
  hello: 'Здравствуйте',
  thanks: 'Спасибо',
  more: 'Ещё',
  yes: 'Да',
  no: 'Нет',
  of: 'из',
  on: 'в',
  by: 'по',
  before: 'до',
  year: 'год',
  month: 'месяц',
  day: 'День',
  from: 'с',
  to: 'по',
  atTime: 'в {time}',
  moveTo: 'переместить в',
  min: 'Минимум',
  max: 'Максимум',
  normal: 'Норма',
  percent: 'Процент',
  shorthands: {
    openQuestions: 'ОВ',
    quarter: 'кв',
    date: {
      year: 'г.',
      months: 'мес.',
    },
    currency: {
      rub: 'руб.',
    },
    months: [
      'янв',
      'фев',
      'март',
      'апр',
      'май',
      'июнь',
      'июль',
      'авг',
      'сент',
      'окт',
      'нояб',
      'дек',
    ],
    days: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
  },
  workDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт'],
  months: [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь',
  ],
  quantity: {
    targets: ['цель', 'цели', 'целей'],
    scores: ['балл', 'балла', 'баллов'],
    requiredHint: ['обязательный', 'обязательных', 'обязательных'],
    email: ['письмо', 'письма', 'писем'],
    evaluation: ['оценка', 'оценки', 'оценок'],
    years: ['год', 'года', 'лет'],
    months: ['месяц', 'месяца', 'месяцев'],
    days: ['день', 'дня', 'дней'],
    numerals: ['-ый', '-ой', '-ий', '-ый'],
    team: ['команда', 'команды', 'команд'],
    task: ['задача', 'задачи', 'задач'],
    people: ['человек', 'человека', 'человек'],
    survey: ['опрос', 'опроса', 'опросов'],
    answer: ['ответ', 'ответа', 'ответов'],
    license: ['лицензия', 'лицензии', 'лицензий'],
    specialization: ['специализация', 'специализации', 'специализаций'],
    employee: ['сотрудник', 'сотрудника', 'сотрудников'],
    user: ['пользователь', 'пользователя', 'пользователей'],
    test: ['тест', 'теста', 'тестов'],
    material: ['материал', 'материала', 'материалов'],
    question: ['вопрос', 'вопроса', 'вопросов'],
    element: ['элемент', 'элемента', 'элементов'],
    minute: ['минута', 'минуты', 'минут'],
    plan: ['план', 'плана', 'планов'],
    selected: {
      masculine: ['Выбран', 'Выбрано', 'Выбрано'],
      feminine: ['Выбрана', 'Выбрано', 'Выбрано'],
    },
    passed: {
      masculine: ['Пройден', 'Пройдено', 'Пройдено'],
      feminine: ['Пройдена', 'Пройдены', 'Пройдено'],
    },
    assigned: {
      masculine: ['Назначен', 'Назначено', 'Назначено'],
      feminine: ['Назначена', 'Назначены', 'Назначено'],
    },
    available: {
      feminine: ['Доступна', 'Доступно', 'Доступно'],
    },
    added: {
      masculine: ['Добавлен', 'Добавлено', 'Добавлено'],
      feminine: ['Добавлена', 'Добавлено', 'Добавлено'],
    },
  },
  validators: {
    required: 'Обязательное поле',
    invalidValue: 'Некорректное значение',
    positiveInt: 'Введите целое положительное число',
    positiveIntWithZero: 'Введите целое положительное число или ноль',
    phone: 'Некорректный номер телефона',
    email: 'Некорректный e-mail',
    minLength: 'Минимум {minLimit} символов',
    minValue: 'Минимальное значение: {minLimit}',
    maxValue: 'Максимальное значение: {maxLimit}',
    maxLength: 'Длина не должна превышать {maxLimit} символов',
    url: 'Некорректный URL',
    file: 'Размер загружаемого файла не должен превышать',
    unique: 'Поля не должны совпадать',
    notMatch: 'Значения не должны совпадать',
    megabytes: 'МБ',
    numeric: 'Допустимы только цифры',
    dtStartEnd: 'Дата начала должна быть не меньше даты завершения',
    denyPastDates: 'Дата должна быть не меньше текущей',
    denyFutureDates: 'Дата должна быть не больше текущей',
  },
  filterLabels: {
    name: 'Название',
    status: 'Статус',
    period: 'Период',
    all: 'Все',
    date: 'Дата',
  },
  imagePicker: {
    cropperTitle: 'Редактировать изображение',
    image: 'Изображение',
  },
  expectationStates: {
    low: 'Ниже ожиданий',
    middle: 'Соответствует ожиданиям',
    high: 'Выше ожиданий',
  },
  feedback: 'Фидбэк',
  generalFeedback: 'Общая обратная связь',
  methodology: 'Методология',
  all: 'Все',
  interconnectExport: {
    title: 'Выгрузить в Excel данные по взаимодействию сотрудников',
    period: 'Выберите период отправки писем, за который хотите получить выгрузку:',
    noData: 'По выбранным сотрудникам нет данных по взаимодействию за выбранный период',
    errorMessage: 'Не удалось проверить доступность выгрузки',
    errorMessageExport: 'Не удалось выгрузить данные',
  },
  commentTypes360: {
    all: 'Все',
    score: 'Зависит от оценки',
    scoreBelow: 'Ниже оценки',
    scoreAbove: 'Выше оценки',
    tooltips: {
      all: 'В процессе оценки респонденты должны будут обязательно оставить комментарий для каждой компетенции.',
      score:
        'В процессе оценки респонденты обязательно должны будут оставить комментарии только для тех компетенций, для которых поставят хотя бы одну оценку выше или равно и/или ниже или равно указанным порогам.',
    },
  },
};
